import React from "react";

const ProductCardSkeleton = () => (
  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden animate-pulse">
    {/* Header */}
    <div className="flex items-center gap-2.5 px-3.5 py-2.5 border-b border-gray-100 bg-gray-50">
      <div className="w-8 h-8 rounded-lg bg-gray-200" />
      <div className="flex-1">
        <div className="h-3.5 bg-gray-200 rounded w-20 mb-1" />
        <div className="h-2.5 bg-gray-100 rounded w-28" />
      </div>
    </div>

    <div className="px-3.5 py-3 space-y-3">
      {/* Kota özeti */}
      <div className="grid grid-cols-2 gap-2">
        <div className="bg-blue-50/50 rounded-lg px-2.5 py-2 border border-blue-50">
          <div className="h-2 bg-blue-100 rounded w-14 mb-1.5" />
          <div className="h-4 bg-blue-100 rounded w-12" />
        </div>
        <div className="bg-amber-50/50 rounded-lg px-2.5 py-2 border border-amber-50">
          <div className="h-2 bg-amber-100 rounded w-16 mb-1.5" />
          <div className="h-4 bg-amber-100 rounded w-8" />
        </div>
      </div>

      {/* Ayarlar rows */}
      <div className="space-y-0">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex items-center justify-between py-1.5">
            <div className="h-2.5 bg-gray-100 rounded w-16" />
            <div className="h-2.5 bg-gray-200 rounded w-10" />
          </div>
        ))}
      </div>

      {/* Kota seviyeleri */}
      <div className="grid grid-cols-2 gap-2">
        <div className="bg-gray-50 rounded-lg px-2.5 py-2 border border-gray-100 text-center">
          <div className="h-2 bg-gray-200 rounded w-8 mx-auto mb-1.5" />
          <div className="h-3.5 bg-gray-200 rounded w-10 mx-auto" />
        </div>
        <div className="bg-gray-50 rounded-lg px-2.5 py-2 border border-gray-100 text-center">
          <div className="h-2 bg-gray-200 rounded w-12 mx-auto mb-1.5" />
          <div className="h-3.5 bg-gray-200 rounded w-12 mx-auto" />
        </div>
      </div>

      {/* Senkronizasyon */}
      <div className="border-t border-gray-100 pt-2.5 space-y-2">
        <div className="flex items-center justify-between">
          <div className="h-2.5 bg-gray-100 rounded w-20" />
          <div className="h-2.5 bg-gray-200 rounded w-6" />
        </div>
        <div className="flex items-center justify-between">
          <div className="h-2.5 bg-gray-100 rounded w-24" />
          <div className="h-4 bg-gray-200 rounded-full w-10" />
        </div>
      </div>
    </div>
  </div>
);

export default ProductCardSkeleton;
